var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"h-4 w-4 mx-1 fill-current cursor-pointer",attrs:{"viewBox":"0 0 20 20"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M10,19.25L4.5,14H8V1h4v13h3.5L10,19.25z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }